var $c8a8deb52a3920b2$exports = {};
const $c8a8deb52a3920b2$var$btnPlayVideo_1 = document.getElementById("play_video_1");
const $c8a8deb52a3920b2$var$btnPlayVideo_2 = document.getElementById("play_video_2");
const $c8a8deb52a3920b2$var$btnPlayVideo_3 = document.getElementById("play_video_3");
const $c8a8deb52a3920b2$var$modalPlayVideo = document.getElementById("modalPlayVideo");
const $c8a8deb52a3920b2$var$contentVideo = document.getElementById("content_video");
const $c8a8deb52a3920b2$var$btnCloseModal = document.getElementById("close_modal");
const $c8a8deb52a3920b2$var$listVideo = [
    {
        id: 1,
        src: "https://mtt-landing-page-assets.s3.ap-southeast-1.amazonaws.com/sukien-video-1.mp4"
    },
    {
        id: 2,
        src: "https://mtt-landing-page-assets.s3.ap-southeast-1.amazonaws.com/sukien-video-2.mp4"
    },
    {
        id: 3,
        src: "https://mtt-landing-page-assets.s3.ap-southeast-1.amazonaws.com/sukien-video-3.mp4"
    }
];
function $c8a8deb52a3920b2$var$openVideoModal(videoId) {
    const video = $c8a8deb52a3920b2$var$listVideo.find((v)=>v.id === videoId);
    if (video) {
        $c8a8deb52a3920b2$var$contentVideo.src = video.src;
        $c8a8deb52a3920b2$var$modalPlayVideo.classList.remove("hidden");
        $c8a8deb52a3920b2$var$contentVideo.play();
    }
}
$c8a8deb52a3920b2$var$btnPlayVideo_1.addEventListener("click", ()=>$c8a8deb52a3920b2$var$openVideoModal(1));
$c8a8deb52a3920b2$var$btnPlayVideo_2.addEventListener("click", ()=>$c8a8deb52a3920b2$var$openVideoModal(2));
$c8a8deb52a3920b2$var$btnPlayVideo_3.addEventListener("click", ()=>$c8a8deb52a3920b2$var$openVideoModal(3));
$c8a8deb52a3920b2$var$btnCloseModal.addEventListener("click", ()=>{
    $c8a8deb52a3920b2$var$modalPlayVideo.classList.add("hidden");
    $c8a8deb52a3920b2$var$contentVideo.pause();
    $c8a8deb52a3920b2$var$contentVideo.src = "";
});


//# sourceMappingURL=index.fbcd48ef.js.map
